import { http } from '@uhg-abyss/web/tools/http';
import { event as eapmEvent } from '@uhg-abyss/web/tools/event';
import { config } from '@uhg-abyss/web/tools/config';
import { lagoon } from '@optum-lagoon/sdk';
import { getLandingStatusError } from './errors';

export const getOnFetchingUserRequest = async (action) => {
  const useUpdatedEndpoints = lagoon
    .getTable('feature-toggles')
    .getRow('US10732847_UPDATED_CORE_V2_ENDPOINTS')?.active;

  const userInfoUrl = useUpdatedEndpoints
    ? `${config('OIDC_API_URL')}/userinfo/v2`
    : `${config('OIDC_API_URL')}/userinfo`;

  const response = await http({
    method: 'GET',
    url: userInfoUrl,
    handleError: getLandingStatusError,
    cache: false,
  });
  const { duration, status, data } = response;
  const successData = {
    endpoint: userInfoUrl,
    duration,
    status,
  };

  eapmEvent('EAPM_TRANSACTION_SUCCESS', successData);

  return data;
};
